import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { ExtractedContract } from "../../../types/contract";

interface EditableGeneralDataTableProps {
  contracts: ExtractedContract[];
  onContractChange: (
    index: number,
    field: keyof ExtractedContract,
    value: any,
  ) => void;
  unmatchedIds: Set<number>;
  onDeleteContract: (index: number, recordId: number) => void;
}

export const EditableGeneralDataTable: React.FC<EditableGeneralDataTableProps> = ({
  contracts,
  onContractChange,
  unmatchedIds,
  onDeleteContract,
}) => {
  const fields: { key: keyof ExtractedContract; label: string }[] = [
    { key: "filename", label: "ファイル名" },
    { key: "property_name", label: "物件名" },
    { key: "room_name", label: "部屋名" },
    { key: "lessee_name", label: "入居者名" },
    { key: "document_type", label: "書類の種類" },
  ];

  const documentTypeOptions = [
    "賃貸借契約書",
    "重要事項説明書",
    "更新契約書",
    "火災保険申込書",
    "家賃保証契約書",
    "その他",
  ];

  return (
    <TableContainer component={Paper}>
      <Table size="small" sx={{ tableLayout: "fixed" }}>
        <TableHead>
          <TableRow>
            {fields.map((f) => (
              <TableCell key={f.key} sx={{ width: "18%" }}>
                {f.label}
              </TableCell>
            ))}
            <TableCell sx={{ width: "10%", textAlign: "center" }}>
              削除
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {contracts.map((contract, index) => (
            <TableRow
              key={contract.id || index}
              sx={{
                backgroundColor: unmatchedIds.has(contract.id!)
                  ? "#ffebee"
                  : "inherit",
              }}
            >
              {fields.map((field) => (
                <TableCell key={field.key}>
                  {field.key === "document_type" ? (
                    <FormControl variant="standard" fullWidth>
                      <Select
                        value={contract[field.key] || ""}
                        onChange={(e) =>
                          onContractChange(index, field.key, e.target.value)
                        }
                      >
                        {documentTypeOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      variant="standard"
                      fullWidth
                      value={
                        field.key === "filename"
                          ? (contract[field.key] || "").split(/[/／]/).pop()
                          : contract[field.key] || ""
                      }
                      placeholder={
                        (contract[field.key] || "") === "" ? "N/A" : ""
                      }
                      onChange={(e) =>
                        onContractChange(index, field.key, e.target.value)
                      }
                      disabled={field.key === "filename"}
                    />
                  )}
                </TableCell>
              ))}
              <TableCell sx={{ textAlign: "center" }}>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => onDeleteContract(index, contract.id)}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(255, 0, 0, 0.1)" },
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};